/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CitationInput = {
  page?: string | null | undefined;
};

export type EvidenceUpsertInput = {
  citation?: CitationInput | null | undefined;
  id?: string | null | undefined;
  referenceId: string;
};

export type GeoItemCoords = {
  lat: number;
  lng: number;
};

export type GeoItemCreateInput = {
  coords?: GeoItemCoords | null | undefined;
  countryCode?: string | null | undefined;
  countrySubdivisionCode?: string | null | undefined;
  geometry?: Types.JsonObject | null | undefined;
  h3Indexes?: Array<string> | null | undefined;
  i18nLabel?: I18nLabelInput | null | undefined;
  metadata?: Types.JsonObject | null | undefined;
  recordGeoItems?: Array<NestedGeoItemRecordGeoItemCreateInput> | null | undefined;
  tenantId: string;
};

export type I18nLabelCanonicalInput = {
  locale: string;
  value: string;
};

export type I18nLabelInput = {
  canonical?: Array<I18nLabelCanonicalInput> | null | undefined;
  en?: string | null | undefined;
  ja?: string | null | undefined;
};

export type NestedGeoItemRecordGeoItemCreateInput = {
  endDate?: string | null | undefined;
  entityOrRelationId: string;
  evidences?: Array<EvidenceUpsertInput> | null | undefined;
  i18nLabel?: I18nLabelInput | null | undefined;
  metadata?: Types.JsonObject | null | undefined;
  startDate: string;
};

export type CreateGeoItemMutationVariables = Exact<{
  input: Types.GeoItemCreateInput;
}>;


export type CreateGeoItemMutation = { cnutCreateGeoItem: { __typename: 'GeoItemOutput', id: string } };


export const CreateGeoItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGeoItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GeoItemCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutCreateGeoItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateGeoItemMutation, CreateGeoItemMutationVariables>;